import * as Yup from "yup";

export function initialValues() {
  return {
    classnumber: [], // Array para guardar clases
    newClass: "", // Input temporal para una nueva clase
  };
}

export function validationSchema(t) {
  return Yup.object({
    classnumber: Yup.array()
      .of(Yup.string().required(t("teachers:validation.classNumberRequired")))
      .min(1, t("teachers:validation.minOneClass")),
  });
}
